import { useEffect } from "react";

export default function SupportRedirect() {
  useEffect(() => {
    window.location.href = "https://discord.gg/qGz3HGgvpe";
  }, []);

  return null;
}
